<template>
  <div class="step-container scrollPosition haus-step-3">
    <div class="step-header">
      <h2 class="step-title">Grundstück</h2>
      <p class="step-text">Steht das Haus auf einem gepachtetem Grundstück?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Gepachtetes Grundstück"
          @click="setRechtsform(20)"
          :iconDefault="require('@/assets/icons/Svgs/haus_gepachtetes_grundstueck.svg')"
          :iconHover="require('@/assets/icons/Svgs/haus_gepachtetes_grundstueck_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Nicht gepachtet"
          @click="setRechtsform(10)"
          :iconDefault="require('@/assets/icons/Svgs/not-existent.svg')"
          :iconHover="require('@/assets/icons/Svgs/not-existent_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";

import {
  saveToStorage,
} from "@/utils.js";
export default {
  name: "haus-step-3",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexRechtsform: { value: null },
      },
    };
  },
  methods: {
    // isSet: isSet,
    setRechtsform(index) {
      this.fields.indexRechtsform.value = index;
      saveToStorage(this.fields);
      this.$router.push("/haus-step-4");

      // const ageOfProperty =
      //     new Date().getFullYear() - getFieldFromStorage("hausBaujahr");
      //   if (ageOfProperty >= Constants.NEW_BUILDING_THRESHOLD) {
      //     this.$router.push("/haus-step-4");
      //   } else {
      //     removeFieldFromStorage("indexArtGebaeudesanierung");
      //     // removeFieldFromStorage("indexHausErhaltung");
      //     this.$router.push("/haus-step-5");
      //   }
    },
    goBack() {
      this.$router.push("/haus-step-2");
},
  },
  mounted() {
    this.$emit("setStep", "haus", 4);
    // getFromStorage(this.fields);
  },
};
</script>
